export default __webpack_public_path__ + "assets/star.e4f1743e.svg";